export default __webpack_public_path__ + "static/media/Avatar1.d5f27cef.png";